<template>
  <component class="kpb-link" :is="tag" v-bind="bindings" :target="target">
    <slot name="default"> {{ label }} </slot>
  </component>
</template>

<script>
export default {
  props: {
    label: String,
    target: {
      type: String,
      default: '_blank',
    },
    tag: {
      type: String,
      default: 'a',
      validator: val => ['a', 'router-link'].includes(val),
    },
    data: {
      type: Object,
      default: () => ({
        href: '',
      }),
    },
  },
  computed: {
    bindings() {
      if (this.tag === 'router-link') {
        return { to: this.data.href }
      }
      return { href: this.data.href }
    },
  },
}
</script>
